<template>
  <div class="toast-message">
    <span class="toast-text">{{ props.message }}</span>
    <button class="toast-close" @click="$emit('close')">×</button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  message: string;
}>();
</script>

<style scoped>
.toast-message {
  display: flex;
  align-items: center;
  background-color: var(--secondary-bg-color);
  color: var(--secondary-text-color);
  padding: 1rem 1.5rem;
  border-radius: 6px;
  margin-bottom: 1rem;
  font-size: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  min-width: 200px;
}

.toast-text {
  flex: 1;
}

.toast-close {
  background: none;
  border: none;
  color: var(--secondary-text-color);
  font-size: 1.5rem;
  cursor: pointer;
  margin-left: 1.5rem;
}
</style>
